import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router";
import CustomButton from "../../Components/CustomButton";
import CustomModal from "../../Components/CustomModal";
import Header from "../../Components/Header";
import { DashboardLayout } from "../../Components/Layout/DashboardLayout";
import Loader from '../../Components/Loader';
import ProfileDisplay from "../../Components/ProfileDisplay";
import usePagination from "../../Hooks/usePagination";
import useSearch from "../../Hooks/useSearch";
import useToggle from "../../Hooks/useToggle";
import { useGetUserStatsQuery, useUpdateUserMutation } from "../../Redux/Apis/User";
import { dateFormatter } from "../../Utils";
import CustomTable from "./../../Components/CustomTable";
import "./style.css";

const sortValues = [
  {
    text: "Name",
    value: "fullName",
  },
  {
    text: "Email",
    value: "email",
  }
];

const perPageValues = [
  {
    text: "8",
    value: 8,
  },
  {
    text: "15",
    value: 15,
  },
  {
    text: "30",
    value: 30,
  }
];

const INTERVALS = [
  {
    label: "Daily",
    value: "daily"
  },
  {
    label: "Weekly",
    value: "weekly"
  },
  {
    label: "Monthly",
    value: "monthly"
  },
  {
    label: "Yearly",
    value: "yearly"
  },
]

const Statistics = () => {

  const [selectedType, setSelectedType] = useState(INTERVALS[0].value)

  const navigate = useNavigate()

  const [itemsPerPage, setItemsPerPage] = useState(perPageValues[0].value);
  const [isFilterOpen, setIsFilterOpen] = useState(false);
  const [sortBy, setSortBy] = useState(sortValues[0].value);
  const [from, setFrom] = useState("");
  const [to, setTo] = useState("");

  const [selected, setSelected] = useState(null);
  const [confirmed, _, toggleConfirmed] = useToggle()
  const [search, debouncedSearch, onSearch] = useSearch()
  const { page, perPage, onNext, onPrevious } = usePagination()
  const { data, isFetching: isLoading, refetch } = useGetUserStatsQuery({
    page,
    rowsPerPage: perPage,
    search: debouncedSearch,
    type: selectedType
  });
  const [changeUserStatus, { data: updatedUser, isSuccess, isLoading: isUpdating }] = useUpdateUserMutation();

  const toggleFilter = () => setIsFilterOpen(!isFilterOpen)

  useEffect(() => {
    if (isSuccess) {
      refetch()
      setSelected(null)
      toggleConfirmed()
    }
  }, [isSuccess])

  const onConfirm = () => {
    changeUserStatus({ _id: selected?._id, active: !selected?.active })
  }

  useEffect(() => {
    document.title = 'Landing List | Statistics';
  }, []);

  const maleHeaders = [
    {
      key: "id",
      title: "S.No",
    },
    {
      key: "name",
      title: "Profile Name",
    },
    {
      key: "createdAt",
      title: "Profile Creation Date",
    },
    {
      key: "actions",
      title: "",
    },
  ];

  const STATS = [
    {
      label: "Visitors",
      value: data?.data?.visitors || "0"
    },
    {
      label: "Registered Users",
      value: data?.data?.total || "0"
    },
  ]

  return (
    <>
      <DashboardLayout>
        <div className="container-fluid">
          <div className="row mb-3">
            <div className="col-12">
              <div className="dashCard">
                <Header title="Statistics" nofilters />
                <div className="row mb-3" style={{ height: "45px", width: "30%", alignSelf: "center", borderRadius: "0.5rem", border: "1px solid #193631", overflow: "hidden" }}>
                  {
                    INTERVALS.map((item) => (
                      <div className="col-3 d-flex align-items-center justify-content-center cursor-pointer" onClick={() => setSelectedType(item.value)} style={{ backgroundColor: selectedType === item.value ? "#193631" : "white" }}>
                        <p className="m-0" style={{ color: selectedType === item.value ? "#ffffff" : "#000", fontWeight: selectedType === item.value ? "600" : "400" }}>{item?.label}</p>
                      </div>
                    ))
                  }
                </div>
                <div className="row bg-white customTable mx-1 py-3 mb-3">
                  {
                    STATS.map((item, index) => (
                      <div className="col d-flex flex-column justify-content-center align-items-center" style={index < STATS.length - 1 ? { borderRight: "1px solid lightgrey" } : {}}>
                        <h4 className="fw-bold">{item.value}</h4>
                        <h6 className="font-sec">{item.label}</h6>
                      </div>
                    ))
                  }
                </div>
                <div className="row mb-3">
                  {
                    isLoading ? <Loader /> :
                      <div className="col-12">
                        <CustomTable
                          headers={maleHeaders}
                          isFilterOpen={isFilterOpen}
                          dateFilter={false}
                          filterSort={true}
                          perPage={true}
                          filterSortValues={sortValues}
                          perPageValues={perPageValues}
                          filterSortValue={sortBy}
                          setFilterSortValue={setSortBy}
                          filterFrom={from}
                          setFilterFrom={setFrom}
                          filterTo={to}
                          setFilterTo={setTo}
                          itemsPerPage={itemsPerPage}
                          setItemsPerPage={setItemsPerPage}
                          length={data?.data?.users?.length}
                          nocheckbox
                          page={page}
                          rowsPerPage={perPage}
                          onNext={onNext}
                          onPrevious={onPrevious}
                          total={data?.total}
                        >
                          <tbody>
                            {data?.data?.users?.map((item, index) => (
                              <tr key={item._id}>
                                <td>{(index + 1) + ((page - 1) * perPage)}</td>
                                <td>
                                  <ProfileDisplay
                                    name={`${item?.first_name} ${item?.last_name}`}
                                    email={`${item?.email}`}
                                    image={`${item?.profile_photo}`}
                                  />
                                </td>
                                <td>{dateFormatter(item.createdAt)}</td>
                                <td className="d-flex justify-content-center align-items-center">
                                  <CustomButton variant="primaryButton" text="View Details" className="mx-1" onClick={() => navigate(`/profiles/${item._id}`)} />
                                  {/* <CustomButton variant="dangerButton" text="Delete" className="mx-1" /> */}
                                  <CustomButton variant={item?.active ? "warningButton" : "dangerButton"} text={item?.active ? "Blacklist" : "Suspended"} className="mx-1" onClick={() => setSelected(item)} />
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </CustomTable>
                      </div>
                  }
                </div>
              </div>
            </div>
          </div>
          <CustomModal loading={isUpdating} show={selected} close={() => setSelected(null)} action={onConfirm} heading={`Are you sure you want to ${selected?.active ? "blacklist" : "active"} this user?`} />
          <CustomModal show={confirmed} close={() => { toggleConfirmed() }} success heading={`User has been ${!updatedUser?.data?.active ? "Suspended" : "Activated"}`} />
        </div>
      </DashboardLayout>
    </>
  );
};

export default Statistics
